export type WheelSegment = {
  readonly id: string;
  readonly name: string;
  readonly short: string;
  readonly prize: boolean;
};

export type WheelLane = "onsite" | "web";

export type WheelCopy = {
  readonly heading: string;
  readonly body: string;
  readonly emailLabel: string;
  readonly codeLabel: string;
  readonly cta: string;
  readonly attract: string;
};

export const DEFAULT_WHEEL_COPY: WheelCopy = {
  heading: "Spin the wheel to\nwin a prize",
  body: "Enter your details for a spin of the wheel. One entry per person, and the prize is yours to collect at the stand.",
  emailLabel: "Enter Your Email",
  codeLabel: "Enter Your Passcode",
  cta: "Spin",
  attract: "Start",
};

export function segmentFromLabel(id: string, label: string): WheelSegment {
  const name = label.trim();
  const blank =
    name === "" ||
    name === "-" ||
    name === "—" ||
    /^not this time$/i.test(name) ||
    /^(try again|better luck(?: next time)?)$/i.test(name);
  return {
    id,
    name: name === "" ? "" : name,
    short: blank ? "-" : name,
    prize: !blank,
  };
}

export function segmentsFromLabels(labels: readonly string[]): WheelSegment[] {
  return labels.map((label, index) => segmentFromLabel(`s${index + 1}`, label));
}
